(function () {
  'use strict';
  const scentWeights = [
    [[4,0,0],[0,4,0],[0,0,4],[1,1,1]],
    [[2,0,0],[0,2,0],[0,0,2]],
    [[2,0,0],[0,2,0],[0,0,2]],
    [[2,0,0],[0,2,0],[0,0,2]],
    [[0,0,0],[0,0,0],[0,0,0]],
    [[0,0,0],[0,0,0],[0,0,0]]
  ];
  const questionKeys = { scent:['s1','s2','s3','s4','s5','s6'], professional:['p1','p2','p3','p4','p5','p6'] };
  const counts = { scent:[4,3,3,3,3,3], professional:[4,3,3,3,3,3] };
  function valid(mode, answers) {
    return Object.hasOwn(counts,mode) && Array.isArray(answers) && answers.length===6 && answers.every((a,i)=>Number.isInteger(a)&&a>=0&&a<counts[mode][i]);
  }
  function score(mode, answers) {
    if (!valid(mode,answers)) throw new Error('Invalid quiz answers');
    if (mode==='professional') {
      if (answers[0]===3) return 'consumer';
      if (answers[0]===2) return 'business';
      if (answers[0]===1 || answers[1]!==0 || answers[3]===0 || answers[4]!==0) return 'prepare';
      return 'qualified';
    }
    const totals=[0,0,0];
    answers.slice(0,4).forEach((a,i)=>scentWeights[i][a].forEach((v,j)=>totals[j]+=v));
    const sorted=totals.map((v,i)=>({v,i})).sort((a,b)=>b.v-a.v);
    return answers[5]===1 || sorted[0].v-sorted[1].v<=2 ? 'set' : ['lemongrass','lavender','cedarwood'][sorted[0].i];
  }
  if (typeof module!=='undefined' && module.exports) module.exports={score,valid,counts};
  if (typeof document==='undefined') return;
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized='true';
    const config=JSON.parse(root.querySelector('[data-quiz-config]').textContent);
    const t=config.text, mode=config.mode, key='ei_quiz_v1_'+mode;
    const stage=root.querySelector('[data-stage]'), gate=root.querySelector('[data-gate]');
    const form=gate.querySelector('form'), status=root.querySelector('[data-status]');
    const storageError=root.querySelector('[data-storage-error]');
    let answers=[], index=0, started=false, result='', pending=false, complete=false, runId='';
    const el=(name,text,cls)=>{const n=document.createElement(name);if(text)n.textContent=text;if(cls)n.className=cls;return n;};
    const button=(label,fn,cls='ei-button')=>{const b=el('button',label,cls);b.type='button';b.addEventListener('click',fn);return b;};
    function emit(name,data={}) {
      try {
        const promise=window.Shopify?.analytics?.publish('ella_iris:'+name,{quiz_id:mode,run_id:runId,...data});
        if (promise?.catch) promise.catch(()=>{});
      } catch (_) {}
    }
    function save() {
      try {sessionStorage.setItem(key,JSON.stringify({answers,index,started,result,pending,complete,runId,time:Date.now()}));return true;}
      catch (_) {storageError.hidden=false;return false;}
    }
    function focusHeading() {const h=stage.querySelector('h2,legend');if(h){h.tabIndex=-1;h.focus();}}
    function intro() {
      gate.hidden=true;stage.replaceChildren();
      stage.append(el('h2',t[mode+'_intro_title']),el('p',t[mode+'_intro_body']),button(t.start,()=>{
        answers=[];index=0;result='';pending=false;complete=false;started=true;
        runId=window.crypto?.randomUUID?.() || String(Date.now())+'-'+Math.random().toString(36).slice(2);
        if (!save()) return;
        emit('quiz_start');question();focusHeading();
      }));
    }
    function question() {
      gate.hidden=true;stage.replaceChildren();
      const progress=el('p',t.progress.replace('{current}',String(index+1)).replace('{total}','6'),'ei-eyebrow');
      const meter=el('progress');meter.max=6;meter.value=index+1;meter.setAttribute('aria-label',progress.textContent);
      const fieldset=el('fieldset'), legend=el('legend',t[questionKeys[mode][index]+'_q']);fieldset.append(legend);
      const nav=el('div',null,'ei-nav');const next=button(index===5?t.finish:t.next,()=>{
        if (answers[index]===undefined) return;
        if(index<5){index++;save();question();focusHeading();}
        else {result=score(mode,answers);pending=false;save();showGate();}
      });next.disabled=answers[index]===undefined;
      for(let a=0;a<counts[mode][index];a++){
        const label=el('label',null,'ei-option'), input=el('input');
        input.type='radio';input.name='ei-'+config.id+'-'+index;input.value=String(a);input.checked=answers[index]===a;
        input.addEventListener('change',()=>{answers[index]=a;next.disabled=false;save();});
        label.append(input,el('span',t[questionKeys[mode][index]+'_a'+a]));fieldset.append(label);
      }
      if(index>0)nav.append(button(t.back,()=>{index--;save();question();focusHeading();},'ei-link-button'));
      nav.append(next);stage.append(progress,meter,fieldset,nav);
    }
    function showGate() {
      stage.replaceChildren(el('h2',t.gate_title),el('p',t.gate_body));
      gate.hidden=false;
      if(form) form.querySelector('[name="contact[tags]"]').value='newsletter,ei-quiz-'+mode+',ei-result-'+result;
      stage.append(button(t.edit,()=>{index=5;pending=false;save();question();focusHeading();},'ei-link-button'));
      focusHeading();
    }
    function showResult() {
      gate.hidden=true;stage.replaceChildren();
      const heading=el('h2',t[result+'_title']);stage.append(el('p',t.result_label,'ei-eyebrow'),heading,el('p',t[result+'_body']));
      if(mode==='scent') {
        const product=config.products[result];
        if(product?.image){const img=el('img');img.src=product.image;img.alt=product.name;img.width=400;img.height=400;img.loading='lazy';stage.append(img);}
        if(product?.url){const link=el('a',product.available?t.shop_match:t.view_match,'ei-button');link.href=product.url;link.addEventListener('click',()=>emit('product_click',{product_key:result}));stage.append(link);}
        if(result!=='set' && config.products.set?.url){const link=el('a',t.compare_set,'ei-secondary');link.href=config.products.set.url;link.addEventListener('click',()=>emit('product_click',{product_key:'set'}));stage.append(link);}
        stage.append(el('p',t['ritual_'+answers[4]],'ei-note'),el('p',t.scent_safety,'ei-note'));
      } else {
        const link=el('a',t[result+'_cta'],'ei-button');link.href=result==='consumer'?config.consumerUrl:config.wholesaleUrl;
        link.addEventListener('click',()=>emit(result==='consumer'?'consumer_route_click':'wholesale_route_click'));
        stage.append(link,el('p',t.pro_note,'ei-note'));
      }
      stage.append(el('p',t.confirm_email,'ei-note'),button(t.restart,()=>{try{sessionStorage.removeItem(key);}catch(_){}intro();focusHeading();},'ei-link-button'));
      focusHeading();
    }
    form?.addEventListener('submit',event=>{
      if(!result || !valid(mode,answers) || !form.checkValidity()){event.preventDefault();form.reportValidity();return;}
      pending=true;
      if(!save()){event.preventDefault();return;}
      status.textContent=t.submitting;
    });
    root.querySelector('[data-signup-link]')?.addEventListener('click',event=>{
      if(!result || !valid(mode,answers)){event.preventDefault();return;}
      pending=true;if(!save()){pending=false;event.preventDefault();}
    });
    root.querySelector('[data-close]')?.addEventListener('click',()=>{window.location.assign(config.consumerUrl);});
    let state;
    try {state=JSON.parse(sessionStorage.getItem(key));} catch (_) {}
    if(state && Date.now()-state.time<30*60*1000 && state.started && typeof state.runId==='string'){
      answers=Array.isArray(state.answers)?state.answers:[];index=Number.isInteger(state.index)?Math.min(5,Math.max(0,state.index)):0;started=true;runId=state.runId;
      result=valid(mode,answers)?score(mode,answers):'';pending=state.pending===true;complete=state.complete===true;
      const signupReturn=new URL(window.location.href);
      const success=config.signupProvider==='forms' ? signupReturn.searchParams.get('ei_signup')===mode : gate.querySelector('[data-success]')?.dataset.success==='true';
      if(config.signupProvider==='forms' && signupReturn.searchParams.has('ei_signup')){signupReturn.searchParams.delete('ei_signup');window.history.replaceState(null,'',signupReturn.pathname+signupReturn.search+signupReturn.hash);}
      if(result && pending && success){
        if(!complete){emit('quiz_lead');emit('quiz_complete');if(mode==='professional'&&result==='qualified')emit('wholesale_qualified');}
        pending=false;complete=true;save();showResult();
      }else if(result && complete){showResult();}
      else if(result && (pending || index===5 && answers[5]!==undefined)){showGate();}
      else {question();}
    }else intro();
  }
  function mount(scope=document){scope.querySelectorAll('[data-ei-quiz]').forEach(initialize);}
  mount();document.addEventListener('shopify:section:load',event=>mount(event.target));
})();
